import React, { useEffect, useState } from 'react';
import TicketView from './TicketView';
import useTicket from 'src/hooks/api/useTicket';
import { CircularProgress } from '@material-ui/core';
import { useRecoilState } from 'recoil';
import { ticketState as ticketStateRecoil } from 'src/recoil/selectors/tickets';
import { useNotifier } from 'src/components/NotificationCenter/AlertNotificationCenter';
import { TicketState } from 'src/interfaces/api/Ticket';

const TicketViewContainer = ({ match, location, history }) => {
  const { id } = match.params;

  const { addNotification } = useNotifier();

  const [ticketState, setTicketState] = useState<TicketState>();
  const [ticket, setTicket] = useRecoilState(ticketStateRecoil(id));
  const [error, setError] = useState<string>();
  const [loading, setLoading] = useState(false);

  const { get: getTicket, close: closeTicket, open: openTicket, dunning: dunningTicket, getTicketState } = useTicket();

  useEffect(() => {
    if (ticket?.id !== id) {
      setLoading(true);

      getTicket(id)
        .then((ticket) => {
          setTicket(ticket);
          setLoading(false);
        })
        .catch((e) => {
          setError(e.message);
          setLoading(false);
        });
    }
  }, [id]);

  useEffect(() => {
    if (ticket && ticketState?.id !== ticket.stateId) {
      setLoading(true);
      getTicketState(ticket.stateId)
        .then((ticketState) => {
          setTicketState(ticketState);
          setLoading(false);
        })
        .catch((e) => {
          setError(e.message);
          setLoading(false);
        });
    }
  }, [ticket]);

  const handleChangeHash = (newHash: string) => {
    history.push(newHash);
  };

  const handleDunningTicket = async (comment?: string) => {
    try {
      const ticket = await dunningTicket(id, comment);
      setTicket(ticket);

      addNotification({
        title: 'Relance effectuée avec succès !',
        alertProps: { color: 'success' },
      });

      return ticket;
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const handleCloseTicket = async (id: string, ticketClosedReasonId: number, comment?: string) => {
    try {
      const ticket = await closeTicket(id, ticketClosedReasonId, comment);
      setTicket(ticket);

      return ticket;
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const handleOpenTicket = async (id: string) => {
    try {
      const ticket = await openTicket(id);
      setTicket(ticket);

      return ticket;
    } catch (e) {
      throw new Error(e.message);
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center' }}>
        <CircularProgress />
      </div>
    );
  }

  if (error || !ticket) {
    return (
      <div style={{ color: '#f44336' }}>
        <p>{error}</p>
      </div>
    );
  }

  return (
    <TicketView
      pageHash={location.hash}
      onChangePageHash={handleChangeHash}
      ticket={ticket}
      ticketState={ticketState}
      onDunningTicket={handleDunningTicket}
      onOpenTicket={handleOpenTicket}
      onCloseTicket={handleCloseTicket}
    />
  );
};

export default TicketViewContainer;
